import { BankOutlineIcon } from './BankOutlineIcon';

/**
 * author: Google
 * id 952ADDE3-5EC1-4AB1-80F1-9FA7AA14AD74
 * name bank-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bank-outline.svg
 * tags
 * - Banking 
 */
export const MuseumOutlineIcon = BankOutlineIcon;
export default MuseumOutlineIcon